import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchSellers, setFiltroSeller, changeSellerStatus } from '../../actions/sellersActions';
import { setTiposPublicacion } from '../../actions/tiposPublicacionActions';
import { limpiarFiltros } from '../../actions/generalActios';
import SellerListItem from './SellerListItem';
import BigSpinner from '../General/BigSpinner';
import FiltroSellers from './FiltroSellers';
import SafeReactPaginate from '../General/SafeReactPaginate';
import { withNavigation } from '../General/withNavigation';
import { fetchExportarSellersApi } from '../../api/axios';
import { base64ToArrayBufferXlsx, saveByteArrayXlsx } from '../../utilities/formatFile';
import { toast } from '../../utilities/appToast';
import MiniSpinner from '../General/MiniSpinner';
import '../General/AdminListCard.css';


class ListSellers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            downloadingSellers: false
        };
        this.INITIAL_REQUEST = {
            razonSocial: "",
            cantidadPagina: 10,
            numeroPagina: 1
        };
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    componentDidMount() {
        if (this.props.isFilterClear) {
            this.buscarSinFiltro();
        } else {
            this.buscarConFiltro();
        }
    }

    buscarSinFiltro = () => {
        const { numeroPagina, cantidadPagina, razonSocial } = this.INITIAL_REQUEST
        this.props.fetchSellers(razonSocial ?? "", cantidadPagina ?? 0, numeroPagina ?? 0);
        this.props.setFiltroSeller({ ...this.INITIAL_REQUEST });
    }

    buscarConFiltro = () => {
        const numeroPagina = this.props.filtro?.numeroPagina ?? this.INITIAL_REQUEST.numeroPagina;
        this.props.fetchSellers(
            this.props.filtro?.razonSocial ?? "",
            this.INITIAL_REQUEST.cantidadPagina,
            numeroPagina,
        );

        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse()
        }
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        this.props.fetchSellers(
            this.props.filtro?.razonSocial ?? "",
            this.INITIAL_REQUEST.cantidadPagina,
            selectedPage
        );
        this.props.setFiltroSeller({ ...this.props.filtro, numeroPagina: selectedPage });

        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse()
        }
    }

    setLimpiarFiltroFalse = () => {
        this.props.limpiarFiltros({ ...this.props.emptyFilters, sellers: false });
    }

    onNew = () => {
        this.props.navigate(`/Sellers/Nuevo`);
    }

    onNewUser = () => {
        this.props.navigate(`/Usuarios/NuevoUser`);
    }

    downloadSellers = async () => {
        this.setState({ downloadingSellers: true });
        try {
            const req = await fetchExportarSellersApi({});
            const blob = base64ToArrayBufferXlsx(req.excelBytes);
            saveByteArrayXlsx("Sellers.xlsx", blob);
        } catch {
            toast.error('No se pudieron descargar los sellers');
        } finally {
            this.setState({ downloadingSellers: false });
        }
    }

    handleToggleStatus = (seller) => {
        const newStatus = seller.estado === "activo" ? "inactivo" : "activo";
        this.props.changeSellerStatus(seller, newStatus).catch(() => {});
    }


    render() {
        const { isLoadingSellers, userType, sellers, filtro } = this.props;
        const rawPageCount =
            sellers?.paginateSellers?.cantidadPagina ??
            sellers?.paginateSellers?.totalPages ??
            0;
        const pageCount = Math.max(0, Number(rawPageCount) || 0);
        const wantedPageIndex =
            filtro?.numeroPagina != null ? filtro.numeroPagina - 1 : 0;
        const paginateForcePage =
            pageCount > 0
                ? Math.min(Math.max(0, wantedPageIndex), pageCount - 1)
                : undefined;

        return (
            <div className="container">
                <div className="row mb-3 mb-md-4 align-items-center py-3 px-2 rounded admin-page-heading" style={{ background: 'linear-gradient(to right, #f8f9fa 0%, #fff 100%)', borderLeft: '4px solid var(--rojo-megatone, #c00)' }}>
                    <div className="col-12 col-sm-5">
                        <h4 className="mb-0 text-themecolor color-rojo-megatone fw-bold">Sellers</h4>
                        <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">
                            Gestión y administración de sellers.
                        </p>
                    </div>

                    <div className="button-group col-12 col-sm-7 mt-2 mt-sm-0 d-flex flex-wrap justify-content-sm-end align-items-end gap-2">
                        {(userType.isCategory || userType.isAdminMod) && (
                            <>
                                {!this.state.downloadingSellers && (
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-green d-inline-flex align-items-center px-3"
                                        onClick={this.downloadSellers}
                                    >
                                        <i className="fa fa-download me-1" aria-hidden="true" />
                                        Descargar sellers
                                    </button>
                                )}
                                {this.state.downloadingSellers && <MiniSpinner />}
                            </>
                        )}

                        <div className="btn-group">
                            <button
                                type="button"
                                className="btn btn-sm background-rojo-megatone text-white dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <i className="fa fa-plus-circle mx-1" />
                                Crear
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end">
                                <li>
                                    <button
                                        type="button"
                                        className="dropdown-item d-flex align-items-center justify-content-between py-2"
                                        onClick={() => this.onNew()}
                                    >
                                        <span className="d-inline-flex align-items-center">
                                            <i className="fas fa-store-alt me-2 text-success" aria-hidden="true" />
                                            Crear Seller Admin
                                        </span>
                                        <span className="badge rounded-pill bg-light text-success border border-success-subtle">
                                            Admin
                                        </span>
                                    </button>
                                </li>
                                {userType.isAdminMod && <li><hr className="dropdown-divider my-1" /></li>}
                                {userType.isAdminMod && (
                                    <li>
                                        <button
                                            type="button"
                                            className="dropdown-item d-flex align-items-center justify-content-between py-2"
                                            onClick={() => this.onNewUser()}
                                        >
                                            <span className="d-inline-flex align-items-center">
                                                <i className="fas fa-user-shield me-2 text-primary" aria-hidden="true" />
                                                Crear Moderador
                                            </span>
                                            <span className="badge rounded-pill bg-light text-primary border border-primary-subtle">
                                                Moderador
                                            </span>
                                        </button>
                                    </li>
                                )}
                            </ul>
                         </div>

                        <FiltroSellers
                            inline
                            getSellers={this.buscarConFiltro}
                            clearFilter={this.buscarSinFiltro}
                        />

                    </div>
                </div>

                {isLoadingSellers && <BigSpinner message="Cargando sellers..." />}
                {!isLoadingSellers && (
                    this.props.sellers?.paginateSellers?.elementos?.length > 0 ? (
                        <ul className="list-group admin-list-stack">
                            {sellers.paginateSellers.elementos.map((seller, index) => (
                                <SellerListItem
                                    key={seller.codigo}
                                    id={seller.codigo}
                                    cuit={seller.cuit}
                                    razonSocial={seller.razonSocial}
                                    codigoPostal={seller.codigoPostal}
                                    telefono={seller.telefono}
                                    estado={seller.estado}
                                    direccion={seller.domicilio}
                                    contactoComercial={seller.email}
                                    emailContacto={seller.emailDespacho}
                                    numeroDomicilio={seller.numeroDomicilio}
                                    localidad={seller.localidad}
                                    provincia={seller.provincia}
                                    onToggleStatus={() => this.handleToggleStatus(seller)}
                                />
                            ))}
                        </ul>
                    ) :
                    <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                        NO SE ENCONTRARON SELLERS
                    </h5>
                )
                }

                <div className="d-flex justify-content-center">
                    <SafeReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={2}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={paginateForcePage}
                    />
                </div>
            </div>
        );
    }
}


/**
 * PropTypes para ListSellers
 * 
 * Este componente recibe props de:
 * 1. Redux (mapStateToProps)
 * 2. Redux actions (mapDispatchToProps)
 * 3. withNavigation HOC (navigate)
 */
ListSellers.propTypes = {
  // ==================== Props de Redux (mapStateToProps) ====================
  sellers: PropTypes.oneOfType([PropTypes.shape({
    paginateSellers: PropTypes.shape({
      elementos: PropTypes.arrayOf(
        PropTypes.shape({
          codigo: PropTypes.number,
          cuit: PropTypes.string,
          razonSocial: PropTypes.string,
          codigoPostal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          telefono: PropTypes.string,
          estado: PropTypes.string,
          domicilio: PropTypes.string,
          email: PropTypes.string,
          emailDespacho: PropTypes.string,
          numeroDomicilio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          localidad: PropTypes.string,
          provincia: PropTypes.string,
        })
      ),
      cantidadPagina: PropTypes.number,
    }),
  }), PropTypes.array]),
  filtro: PropTypes.oneOfType([PropTypes.shape({
    razonSocial: PropTypes.string,
    cantidadPagina: PropTypes.number,
    numeroPagina: PropTypes.number,
    showFilter: PropTypes.bool,
  }), PropTypes.array]),
  userType: PropTypes.shape({
    isAdminMod: PropTypes.bool,
    isSeller: PropTypes.bool,
    isSellerAdmin: PropTypes.bool,
    isSoloLectura: PropTypes.bool,
    isProveedor: PropTypes.bool,
  }),
  isFilterClear: PropTypes.bool,
  emptyFilters: PropTypes.shape({
    publicaciones: PropTypes.bool,
    ordenes: PropTypes.bool,
    sellers: PropTypes.bool,
    dashboard: PropTypes.bool,
    rebates: PropTypes.bool,
    liquidaciones: PropTypes.bool,
    grupoPlanes: PropTypes.bool,
  }),
  isLoadingSellers: PropTypes.bool,

  // ==================== Props de Actions (mapDispatchToProps) ====================
  fetchSellers: PropTypes.func.isRequired,
  setFiltroSeller: PropTypes.func.isRequired,
  limpiarFiltros: PropTypes.func.isRequired,
  changeSellerStatus: PropTypes.func.isRequired,

  // ==================== Props de withNavigation HOC ====================
  navigate: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    idSeller: state.general.idSeller,
    sellers: state.sellers.sellers,
    filtro: state.sellers.filtro,
    userType: state.general.userType,
    isFilterClear: state.general.limpiar.sellers,
    emptyFilters: state.general.limpiar,
    isLoadingSellers: state.sellers.loadingSellers,
});

export default withNavigation(connect(mapStateToProps, {
    fetchSellers,
    limpiarFiltros,
    setFiltroSeller,
    setTiposPublicacion,
    changeSellerStatus
})(ListSellers));